
export class HowToRespondController {

    isOnlineOrAwaiting: boolean;
    isToBeMatch: boolean;
    isRematch: boolean;
    isActiveApp: boolean;
    isPlacedOrActive: boolean;
    isPlaced: boolean;
    matchingVideo;
    findFamiliesVideo;
    interestedFamiliesCount: any

    currentLikes: number;
    maxLikes: number;

    isApplicant: boolean;

    static $inject = ['$scope', '$sce', '$uibModal', 'dialogs', 'applicationId', 'PlacementMatchesDetails', 'InterestedHostFamiliesDetails', 'applicationObservable', '$state', '$stateParams', 'Auth']
    constructor($scope: angular.IScope, $sce, private $uibModal, private dialogs, public applicationId, public PlacementMatchesDetails, public InterestedHostFamiliesDetails, applicationObservable, private $state, private $stateParams, private Auth) {

        this.isApplicant = Auth.user.isApplicant;

        this.matchingVideo = [
            { src: $sce.trustAsResourceUrl("https://aupairamericalive.s3.amazonaws.com/resources/I/Matching%20Video.mp4"), type: 'video/mp4' }
        ],

        this.findFamiliesVideo = [
            { src: $sce.trustAsResourceUrl("https://aupairamericalive.s3.amazonaws.com/resources/I/Finding%20Video.mp4"), type: 'video/mp4' }
        ],

        applicationObservable.subscribe(applicationInstance => {
            this.isToBeMatch = (applicationInstance.status === 'TBM');
            this.isRematch = (applicationInstance.status === 'REM');
            this.isActiveApp = (applicationInstance.status === 'ACT');
            this.isPlaced = (applicationInstance.status === 'PLC');
            this.isOnlineOrAwaiting = (applicationInstance.status === 'OLA' || applicationInstance.status === 'AWA');
            this.isPlacedOrActive = (applicationInstance.status === 'PLC' || applicationInstance.status === 'ACT');


            if (this.isToBeMatch || this.isActiveApp) {
                this.interestedFamiliesCount = InterestedHostFamiliesDetails.count({
                    applicationId: this.applicationId
                });
            }
        })

        this.InterestedHostFamiliesDetails.limits({ applicationId: this.applicationId })
            .$promise
            .then((limits) => {
                this.currentLikes = limits.currentLikes;
                this.maxLikes = limits.maxLikes;
            })

    }

    hostFamiliesState() {
        return this.isApplicant ? "app.hostFamilies.interestedFamilies" : "app.applications.hostFamilies.interestedFamilies";
    }

}

angular
    .module('app')
    .controller('HowToRespondController', HowToRespondController)
